import { atom } from "jotai";

export const modalStatusAtom = atom<{[id: string]: boolean}>({});